import { Dispatch } from 'react';
import { CancelToken } from 'axios';
import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';

import { ModelData } from 'bloko/common/tree/types';

import { NonNullableAppStore } from 'src/app/store';
import { RegionsListAdditional } from 'src/components/Price/RegionSelectorPopup/RegionsList';
import { PriceDataTab } from 'src/models/price/priceData';
import { fetcher } from 'src/utils/fetcher';

interface ServiceResponse {
    priceRegions: ModelData<RegionsListAdditional>[];
}

declare global {
    interface FetcherGetApi {
        '/shards/price/price_regions': {
            response: ServiceResponse;
            queryParams: {
                areaId: string;
                tabName?: PriceDataTab;
                employerId?: string;
            };
        };
    }
}

interface LoadPriceRegionsArgs {
    areaId: string;
    tabName?: PriceDataTab;
    cancelToken?: CancelToken;
}

const loadPriceRegions =
    ({ areaId, tabName, cancelToken }: LoadPriceRegionsArgs) =>
    (
        dispatch: Dispatch<ThunkAction<Promise<ServiceResponse>, NonNullableAppStore, unknown, AnyAction>>,
        getState: () => NonNullableAppStore
    ): Promise<ServiceResponse> => {
        const employerId = getState().priceData.priceEmployerId;

        return fetcher
            .get('/shards/price/price_regions', { params: { areaId, tabName, employerId }, cancelToken })
            .then((data) => {
                if (data.priceRegions) {
                    return data;
                }
                return Promise.reject(new Error('Missing priceRegions'));
            });
    };

export default loadPriceRegions;
